import { render, staticRenderFns } from "./OrderPay.vue?vue&type=template&id=ec589da0&scoped=true"
import script from "./OrderPay.vue?vue&type=script&lang=js"
export * from "./OrderPay.vue?vue&type=script&lang=js"
import style0 from "./OrderPay.vue?vue&type=style&index=0&id=ec589da0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec589da0",
  null
  
)

export default component.exports